import { Badge, Tooltip } from '@payaca/ambrosia';
import { FunctionComponent, type JSX } from 'react';

const MAX_VISIBLE_TEAMS = 2;

type TeamBadge = { id: string; name: string };

/**
 * Renders a user's team memberships as badges, capping the number shown and
 * collapsing the rest into a "+N" badge that reveals the full list on hover.
 */
const UserTeamsCell: FunctionComponent<{ teams: TeamBadge[] }> = ({
  teams,
}): JSX.Element => {
  const visibleTeams = teams.slice(0, MAX_VISIBLE_TEAMS);
  const hiddenCount = teams.length - visibleTeams.length;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visibleTeams.map((team) => (
        <Badge key={team.id} variant="soft">
          {team.name}
        </Badge>
      ))}
      {hiddenCount > 0 && (
        <Tooltip
          tooltipContent={
            <div className="flex flex-col gap-0.5">
              {teams.map((team) => (
                <span key={team.id}>{team.name}</span>
              ))}
            </div>
          }
        >
          <Badge variant="soft">+{hiddenCount}</Badge>
        </Tooltip>
      )}
    </div>
  );
};

export default UserTeamsCell;
